/* unplugin-vue-components disabled */import { render } from "./SubmitOrders.vue?vue&type=template&id=3d8dd318"
import script from "./SubmitOrders.vue?vue&type=script&lang=js"
export * from "./SubmitOrders.vue?vue&type=script&lang=js"

import "./SubmitOrders.vue?vue&type=style&index=0&id=3d8dd318&less=true&lang=css"

import exportComponent from "D:\\星网代码\\2018-05-18 路特利\\2022-02-23需求\\DM.LtlApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__